// extracted by mini-css-extract-plugin
export var pillWrapper = "_y0-0";
export var showOverflow = "_y0-1";